import * as React from 'react';
import { Card, CardHeader, Divider } from '@mui/material';
import dayjs from 'dayjs';

import type { Announcement } from '@/types/announcement';
import { PropertyList } from '@/components/core/v2/property-list';
import { PropertyItem } from '@/components/core/v2/property-item';
import { toTitleCase } from '@/utils/to-title-case';

interface AnnouncementInfoCardProps {
  announcement: Announcement;
  isLoading: boolean;
  error: any;
}

export function AnnouncementInfoCard({ announcement }: AnnouncementInfoCardProps): React.JSX.Element {
  return (
    <Card>
      <CardHeader title="Details" />
      <PropertyList divider={<Divider />} orientation="vertical" stripe="odd">
        <PropertyItem name="Type" value={announcement?.type ? toTitleCase(announcement.type as string) : '—'} />
        <PropertyItem name="Status" value={announcement?.status ? toTitleCase(announcement.status as string) : '—'} />
        <PropertyItem
          name="Created"
          value={announcement?.created_at ? dayjs(announcement.created_at).format('MMM DD, YYYY hh:mm A') : '—'}
        />
        <PropertyItem
          name="Scheduled For"
          value={announcement?.scheduled_at ? dayjs(announcement.scheduled_at).format('MMM DD, YYYY hh:mm A') : '—'}
        />
        <PropertyItem
          name="Delivered On"
          value={announcement?.processed_on ? dayjs(announcement.processed_on).format('MMM DD, YYYY hh:mm A') : '—'}
        />
        <PropertyItem
          name="Visibility"
          value={announcement?.board_members_only ? 'Board Members Only' : 'All Users'}
        />
      </PropertyList>
    </Card>
  );
}


